import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
const testimonials = [{
  name: 'María González',
  role: 'Dueña de tienda online',
  quote: 'En solo 2 semanas recuperé mi inversión del curso. Ahora mis anuncios generan ventas todos los días.',
  rating: 5,
  initials: 'MG',
  color: 'from-pink-500 to-rose-500'
}, {
  name: 'Carlos Rodríguez',
  role: 'Coach de fitness',
  quote: 'Pasé de gastar dinero sin resultados a tener un flujo constante de clientes. El módulo de segmentación cambió todo.',
  rating: 5,
  initials: 'CR',
  color: 'from-blue-500 to-cyan-500'
}, {
  name: 'Ana Martínez',
  role: 'Consultora de marketing',
  quote: 'Explicado de forma tan clara que hasta mi mamá podría crear anuncios. Excelente inversión.',
  rating: 5,
  initials: 'AM',
  color: 'from-purple-500 to-violet-500'
}, {
  name: 'Roberto Sánchez',
  role: 'Dueño de restaurante',
  quote: 'Duplicamos las reservas en el primer mes. Las plantillas incluidas son oro puro.',
  rating: 5,
  initials: 'RS',
  color: 'from-orange-500 to-amber-500'
}, {
  name: 'Laura Pérez',
  role: 'Emprendedora digital',
  quote: 'El mejor curso de Meta Ads en español. Práctico, directo y sin relleno. 100% recomendado.',
  rating: 5,
  initials: 'LP',
  color: 'from-green-500 to-emerald-500'
}, {
  name: 'Diego Fernández',
  role: 'Agencia de viajes',
  quote: 'Antes pagaba a una agencia $500/mes. Ahora manejo mis propios anuncios y obtengo mejores resultados.',
  rating: 5,
  initials: 'DF',
  color: 'from-indigo-500 to-blue-500'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-gray-50 py-20 sm:py-28" data-id="element-186">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-187">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} data-id="element-188">
          {/* Section header */}
          <motion.div variants={itemVariants} className="mb-12 text-center" data-id="element-189">
            <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-electric-blue/10 to-bright-orange/10 px-4 py-2 text-sm font-semibold text-electric-blue" data-id="element-190">
              <StarIcon className="h-4 w-4" data-id="element-191" />
              Testimonios
            </span>
            <h2 className="font-heading text-3xl font-extrabold text-gray-900 sm:text-4xl md:text-5xl" data-id="element-192">
              Lo Que Dicen Nuestros Estudiantes
            </h2>
          </motion.div>
        </motion.div>

        {/* Testimonials carousel */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="scrollbar-hide -mx-4 flex snap-x snap-mandatory gap-6 overflow-x-auto px-4 pb-4 sm:-mx-6 sm:px-6" data-id="element-193">
          {testimonials.map((testimonial, index) => <div key={index} className="w-[320px] flex-shrink-0 snap-center sm:w-[380px]" data-id="element-194">
              <div className="h-full rounded-2xl bg-white p-6 shadow-lg sm:p-8" data-id="element-195">
                {/* Quote icon */}
                <QuoteIcon className="mb-4 h-8 w-8 text-electric-blue/20" data-id="element-196" />

                {/* Rating */}
                <div className="mb-4 flex gap-1" data-id="element-197">
                  {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-bright-orange text-bright-orange" data-id="element-198" />)}
                </div>

                {/* Quote */}
                <p className="mb-6 text-gray-700" data-id="element-199">"{testimonial.quote}"</p>

                {/* Author */}
                <div className="flex items-center gap-4" data-id="element-200">
                  <div className={`flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br ${testimonial.color} text-sm font-bold text-white`} data-id="element-201">
                    {testimonial.initials}
                  </div>
                  <div data-id="element-202">
                    <p className="font-heading font-bold text-gray-900" data-id="element-203">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-204">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </div>)}
        </motion.div>

        {/* Scroll hint */}
        <p className="mt-6 text-center text-sm text-gray-500" data-id="element-205">
          ← Desliza para ver más testimonios →
        </p>
      </div>
    </section>;
}